export function get(obj: any, path: string, def?: any) {
  const fullPath = path.replace(/\[/g, '.').replace(/]/g, '').split('.').filter(Boolean);

  return fullPath.every(everyFunc) ? obj : def;

  function everyFunc(step: string) {
    return !(step && (obj = obj[step]) === undefined);
  }
}
